// ENERGY v2 — one rental, as a sheet over the list (?rental=<id>) (UI rebuild batch 4, adopted by the energy lane).
// What a row on Energy.tsx carries, in Astra's detail shape: the facts, ONE A LINE (his words, 1 Nov 2026: "check everything where
// it applies" — the energy and its term were one line), then what the desk recorded against it, each warning in its box, then — for
// one it cannot settle itself — the buttons that do. ONE COPY: the note lines and the settle are screens/Energy.tsx's
// (RentalNoteLines, SettleLines): the same call (api.energySettle), the same confirm() sentences, "not charged" never offered for an
// order the provider accepted, the same refusal lines; a read-only admin is told that settling needs full access.
import type { EnergyAlarm, EnergyRental, EnergyStatus } from '../../../lib/api';
import { fmtRelative, fmtStamp } from '../../../lib/format';
import { DetailSheet, Fact } from '../kit';
import { CopyRef } from '../../CopyRef';
import { Pill } from '../../Pill';
import { AlarmLine, EnergyFigure, TrxFigure, V2_SLABS } from './parts';
import {
  RentalNoteLines, SettleLines, endsIn, lasts, mask, rentalSeat, rentalTrx, secondsUntil, walletName,
} from '../../../screens/Energy';

export function RentalSheet({ r, d, canChange, alarms, onClose }: {
  r: EnergyRental; d: EnergyStatus; canChange: boolean;
  /** The desk's alarms that name this rental — said here in full when the list's row carries them (Energy v2, `carried`). */
  alarms: readonly EnergyAlarm[];
  onClose: () => void;
}) {
  const cost = rentalTrx(r);
  const seat = rentalSeat(r);
  return (
    <DetailSheet title={`Rental #${r.id}`} onClose={onClose}>
      <div className="mb-4">
        <Pill tone={seat.tone}>{seat.word}</Pill>
      </div>
      <div>
        <Fact label="Wallet">{walletName(d, r)}</Fact>
        <Fact label="Kind">{r.purpose === 'standing' ? 'Standing order' : 'Rent energy'}</Fact>
        <Fact label="Energy"><EnergyFigure n={r.energy} /></Fact>
        <Fact label="Term">{lasts(r.durationSec)}</Fact>
        <Fact label="TRX"><TrxFigure value={cost.text} title={cost.tip} /></Fact>
        <Fact label="Sent"><span title={fmtRelative(r.createdAt)}>{fmtStamp(r.createdAt)}</span></Fact>
        {r.state === 'delegated' && r.expiresAt && <Fact label="Ends"><span title={endsIn(secondsUntil(r.expiresAt, d.asOf))}>{fmtStamp(r.expiresAt)}</span></Fact>}
        <Fact label="To"><CopyRef value={r.receiver} label={mask(r.receiver)} /></Fact>
      </div>

      {/* What the desk recorded against it, and — for one it cannot settle itself — the buttons that do. */}
      <div className="mt-4 space-y-3">
        {alarms.map((a) => <AlarmLine key={a.key} a={a} d={d} />)}
        <RentalNoteLines r={r} slabs={V2_SLABS} />
        <SettleLines r={r} canChange={canChange} stacked btn="btn-secondary px-3 text-body disabled:opacity-50" />
      </div>
    </DetailSheet>
  );
}
